import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const BucketConfigCard = ({ bucket, onEdit, onRemove, onTestConnection }) => {
  const [isTesting, setIsTesting] = useState(false);

  const handleTestConnection = async () => {
    setIsTesting(true);
    await onTestConnection(bucket?.id);
    setIsTesting(false);
  };

  const getStatusColor = () => {
    switch (bucket?.status) {
      case 'connected':
        return 'text-success';
      case 'error':
        return 'text-error';
      case 'testing':
        return 'text-warning';
      default:
        return 'text-muted-foreground';
    }
  };

  const getStatusIcon = () => {
    switch (bucket?.status) {
      case 'connected':
        return 'CheckCircle2';
      case 'error':
        return 'XCircle';
      case 'testing':
        return 'Loader2';
      default:
        return 'Circle';
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 hover:border-primary/50 transition-all duration-200">
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center gap-3 flex-1 min-w-0">
          <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
            <Icon name="Database" size={20} color="var(--color-primary)" />
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="text-base font-semibold text-foreground truncate">{bucket?.name}</h3>
            <p className="text-sm text-muted-foreground font-mono truncate">{bucket?.region}</p>
          </div>
        </div>
        <div className={`flex items-center gap-2 ${getStatusColor()}`}>
          <Icon 
            name={getStatusIcon()} 
            size={16} 
            className={bucket?.status === 'testing' ? 'animate-spin' : ''} 
          />
          <span className="text-xs font-medium capitalize">{bucket?.status}</span>
        </div>
      </div>
      <div className="space-y-3 mb-4">
        <div>
          <p className="text-xs text-muted-foreground mb-1">Bucket Name</p>
          <p className="text-sm font-medium text-foreground font-mono truncate">{bucket?.bucketName}</p>
        </div>
        <div>
          <p className="text-xs text-muted-foreground mb-1">Public URL</p>
          <p className="text-sm font-medium text-foreground font-mono truncate">{bucket?.publicUrl}</p>
        </div>
        <div className="grid grid-cols-2 gap-3">
          <div>
            <p className="text-xs text-muted-foreground mb-1">Access Key</p>
            <p className="text-sm font-medium text-foreground font-mono">••••••{bucket?.accessKey?.slice(-4)}</p>
          </div>
          <div>
            <p className="text-xs text-muted-foreground mb-1">Last Tested</p>
            <p className="text-sm font-medium text-foreground font-mono">{bucket?.lastTested}</p>
          </div>
        </div>
      </div>
      {bucket?.errorMessage && (
        <div className="mb-4 p-3 bg-error/10 border border-error/20 rounded-md">
          <div className="flex items-start gap-2">
            <Icon name="AlertCircle" size={16} className="text-error flex-shrink-0 mt-0.5" />
            <p className="text-xs text-error">{bucket?.errorMessage}</p>
          </div>
        </div>
      )}
      <div className="flex items-center gap-2">
        <Button
          variant="outline"
          size="sm"
          iconName="RefreshCw"
          iconPosition="left"
          onClick={handleTestConnection}
          loading={isTesting}
          className="flex-1"
        >
          Test Connection
        </Button>
        <Button
          variant="outline"
          size="sm"
          iconName="Edit2"
          iconPosition="left"
          onClick={() => onEdit(bucket)}
        >
          Edit
        </Button>
        <Button
          variant="destructive"
          size="sm"
          iconName="Trash2"
          onClick={() => onRemove(bucket?.id)}
        >
        </Button>
      </div>
    </div>
  );
};

export default BucketConfigCard;